import { render, staticRenderFns } from "./revised.vue?vue&type=template&id=725ce42b&scoped=true&"
import script from "./revised.vue?vue&type=script&lang=js&"
export * from "./revised.vue?vue&type=script&lang=js&"
import style0 from "./revised.vue?vue&type=style&index=0&id=725ce42b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725ce42b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
